
import { tr } from './translate'
import Arrow from '@/assets/icons/support_ticket/arrow.svg?inline'
import Send from '@/assets/icons/support_ticket/send.svg?inline'

export default {
  components: { Arrow, Send },
  props: {
    config: {
      type: Object,
      default: null,
    },
    step: {
      type: String,
      required: true,
    },
    isEndStep: {
      type: Boolean,
      default: false,
    },
    canNext: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    buttons() {
      return this.config?.ui?.buttons
    },
    showBack() {
      return this.step !== 'category' &&
    (!this.isEndStep || this.step === 'training_info' || this.step === 'order_redirect')
    },
    isTicketForm() {
      return this.step === 'ticket_form'
    },
    label() {
      if (this.isEndStep) {
        return this.tr(this.buttons?.close)
      }
      if (this.isTicketForm) {
        return this.tr(this.buttons?.submit_ticket)
      }
      return this.tr(this.buttons?.continue)
    },
    disabled() {
      return (!this.isEndStep && !this.canNext) || this.loading
    },
  },
  methods: {
    tr(entry) {
      return tr(entry, this.$i18n.locale)
    },
  },
}
